import importTranslations from "../components/import/_langs/en-US";
import mainTranslations from "../modules/main/_langs/en-US";
import { mcpConsentEnUS } from "../modules/main/mcp-consent/_langs/en-US";
import settingsTranslations from "../modules/settings/_langs/en-US";

export default {
  components: {
    slackConnectionBanner: {
      connectMessage: "Connect your Slack workspace to use Invup in Slack.",
      connectCta: "Connect Slack",
      reconnectMessage:
        "Invup needs a quick reconnect to add new Slack features.",
      reconnectCta: "Reconnect Slack",
      missingScopes: "Missing permissions: {{scopes}}",
      reportsConnectConsequence:
        "Connect Slack to deliver report subscriptions to a channel.",
      reportsReconnectConsequence:
        "Report subscriptions can't be delivered until Slack is reconnected.",
      notConnectedAskAdmin:
        "Slack isn't connected, so report subscriptions can't be delivered. Ask an admin to connect Slack.",
      needsReconnectAskAdmin:
        "Slack needs to be reconnected before report subscriptions can be delivered. Ask an admin to reconnect Slack.",
      statusLoadError:
        "Sorry, Slack status could not be loaded due to an error on our end. Please try again later.",
      retryCta: "Try Again",
      installError:
        "Sorry, Slack could not be connected due to an error on our end. Please try again later.",
    },
  },
  import: importTranslations,
  main: mainTranslations,
  mcpConsent: mcpConsentEnUS,
  settings: settingsTranslations,
};
